const T360LogoPrimary = {
    lighter: '#61514E',
    light: '#61514E',
    main: '#61514E',
    dark: '#FFFFFF',
    darker: '#FFFFFF',
  };
const T360LogoSecondary = {
    lighter: '#ED4738',
    light: '#ED4738',
    main: '#ED4738',
    dark: '#ED4738',
    darker: '#ED4738',
  };

export { T360LogoPrimary, T360LogoSecondary };